import { useNav } from '@hero/web-hooks';
import { PublishOrderPage } from '@hero/web-components';

/**
 * Single-page publish-order experience for the carrier dashboard.
 * State + APIs are owned by `@hero/web-components`'s `PublishOrderPage`
 * (Zustand store + `@hero/api-hooks`); this wrapper only supplies the
 * "Back to dashboard" navigation hook so the success view can leave
 * the create flow.
 *
 * Mounted at `/dashboard/new-order` (typed name `new_order`); see
 * `apps/carrier-dashboard/src/app/app.tsx` for the route registration.
 */
export default function CreateOrderPage() {
  const { navigate } = useNav();
  return <PublishOrderPage onClose={() => navigate('dashboard')} />;
}
